// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/wind-triangle.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/wind-triangle/wind-triangle.js';

mount([g0]);
